/* eslint-disable no-unused-vars */
import React from 'react';
import { useFormikContext } from 'formik';

import useComparable from '~/commons/hooks/useComparable';
import ListResource from '../lists/ListResource.jsx';
import FieldArrayCards from './FieldArrayCards.jsx';

import { isPermitted } from '../layout/Nav.jsx';

const FieldListSelect = ({
  name,
  label,
  list: {
    className = 'col-6', onRowClick, segment, ...rest
  } = {},
  pushUnique = false,
  children,
  status,
  setValues,
  values,
}) => {
  const disabled = status?.disabled;
  return (
    <>
      {label && label}
      <div className="row">
        <div className={className}>
          {isPermitted(segment) && (
            <ListResource
              {...{
                searchable: true,
                actions: {
                  create: false,
                  remove: false,
                },
                ...rest,
                onRowClick: (row) => {
                  if (disabled) {
                    return null;
                  }
                  if (onRowClick) {
                    return onRowClick(row);
                  }
                  if (pushUnique) {
                    const { [name]: data } = values;
                    if (data.some((v) => v._id === row._id)) {
                      return null;
                    }
                    return setValues((v) => ({
                      ...v,
                      [name]: [...data, row],
                    }));
                  }
                  return setValues((v) => ({
                    ...v,
                    [name]: row,
                  }));
                },
              }}
            />
          )}
        </div>
        <div className="col">
          {typeof children === 'function' ? children({
            values, status, setValues,
          }) : children}
        </div>
      </div>
    </>
  );
};

const render = (props) => {
  const { values, status, setValues } = useFormikContext();
  const comparable = [values, status, props].map(useComparable);

  return React.useMemo(
    () => (
      <FieldListSelect
        {...{
          ...props,
          values,
          status,
          setValues,
        }}
      />
    ),
    [comparable],
  );
};
export default render;
